import { useState } from "react";
import useRead from "../../hooks/useRead";

const useGetTodaysPunches = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [pagination, setPagination] = useState({
    page_number: 0,
    limit: 25
  });
  
  const { list, paramsObject, setGetListParams } = useRead({
    url: "fetch_todays_punch",
    initialData: { 
      search_query: searchQuery,
      page_number: pagination.page_number,
      limit: pagination.limit
    },
    method: "GET"
  });

  const isLoading = list.isLoading;
  const data = list.data?.data || [];
  const error = list.error;
  
  // Pagination information from the API response
  const paginationInfo = {
    totalCount: list.data?.total_count || 0,
    perPage: list.data?.per_page || 10,
    currentPage: list.data?.page_no || 0
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    setGetListParams({ ...paramsObject, search_query: query });
  };

  const handlePagination = (page) => {
    setPagination({
      ...pagination,
      page_number: page
    });
    
    setGetListParams({ 
      ...paramsObject, 
      page_number: page
    });
  };

  return {
    data,
    isLoading,
    error,
    handleSearch,
    handlePagination,
    paginationInfo
  };
};

export default useGetTodaysPunches;
